// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toast-container{position:fixed;width:100%;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;bottom:0;left:0}.toast{margin-bottom:80px;padding:16px 20px;text-align:center;max-width:300px;border:1px solid #e6e6e6;background-color:#fff;border-radius:15px;box-shadow:0 8px 30px 0 rgba(0,0,0,.3)}.toast.toast-error{background-color:red;border:1px solid #c00;color:#fff}", ""]);
// Exports
module.exports = exports;
